/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import editSetupSettingsTemplate from './edit-setup-settings.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.admin.editSetupSettings', [])
    .directive('agEditSetupSettings', EditSetupSettings)
    .name;

/*@ngInject*/
function EditSetupSettings() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: EditSetupSettingsController,
        controllerAs: 'vm',
        templateUrl: editSetupSettingsTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function EditSetupSettingsController($rootScope, $scope, $translate, $timeout, userService, agSetupSettingsService) {

    let vm = this;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN';
    vm.setupSettings = null;

    vm.save = save;
    vm.cancel = cancel;
    vm.blockedUser = false;
    // vm.endPaymentDate = null;

    var defaultTitle = $translate.instant('ag.setup-settings.tenant-setup-settings');

    $scope.$watch('vm.ctx', function () {
        if (vm.showData && vm.ctx) {
            vm.isEdit = vm.ctx.isEdit;
            vm.ctx.widgetTitle = defaultTitle;
        }
    });

    $scope.$watch(function () {
        return vm.setupSettings ? vm.setupSettings.tenantInfoAsset.name : defaultTitle;
    }, function (title) {
        if (vm.showData && vm.ctx) {
            vm.ctx.widgetTitle = angular.copy(title);
        }
    });

    $scope.$on('editModeChanged', function () {
        vm.isEdit = vm.ctx.isEdit;
    });

    $scope.$on('tenantAssetSelected', function (event, assetId) {
        if (vm.showData) {
            reload(assetId);
        }
    });

    function reload(assetId) {
        if (!vm.setupSettings || !angular.equals(vm.setupSettings.tenantInfoAsset.id, assetId)) {
            vm.loading = true;
            vm.origSetupSettings = null;
            vm.setupSettings = null;
            if (assetId) {
                agSetupSettingsService.getSetupSettings(assetId.id).then(
                    function success(tenant) {
                        let endPaymentDate = new Date(tenant.customer.endPaymentDate);
                        if(tenant.customer.endPaymentDate === 1) {
                            vm.blockedUser = true;
                            tenant.customer.daysBeforeWarning = 0;
                        } else {
                            vm.blockedUser = false;
                        }

                        vm.origSetupSettings = tenant;
                        vm.setupSettings = angular.copy(tenant);
                        vm.setupSettings.customer.endPaymentDate = endPaymentDate;
                        vm.loading = false;
                        resetFormState();
                    }
                );
            } else {
                vm.loading = false;
            }
        }
    }

    function resetFormState() {
        $timeout(function () {
            vm.theForm.$setPristine();
            vm.theForm.$setUntouched();
        });
    }

    function save() {
        if (!vm.setupSettings.customerUserPassword || 0 === vm.setupSettings.customerUserPassword.length) {
            vm.setupSettings.customerUserPassword = null;
        }
        if (vm.setupSettings.customerUser) {
            if (!vm.setupSettings.customerUser.email || 0 === vm.setupSettings.customerUser.email.length) {
                vm.setupSettings.customerUser.email = null;
            }
        }
        let setupSettings = angular.copy(vm.setupSettings);
        if(vm.blockedUser) {
            setupSettings.customer.endPaymentDate = 1;
            setupSettings.customer.daysBeforeWarning = 0;
        } else {
            setupSettings.customer.endPaymentDate = Date.parse(vm.setupSettings.customer.endPaymentDate);
        }

        agSetupSettingsService.addSetupSettings(setupSettings).then(
            function success() {
                vm.theForm.$setPristine();
                vm.theForm.$setUntouched();
                // vm.setupSettings = setupSettings;
                $rootScope.$broadcast('reloadTenantAssets');
            }
        );
    }

    function cancel() {
        vm.setupSettings = angular.copy(vm.origSetupSettings);
        resetFormState();
    }
}
